// assets/menu-dropdown.js
// Desktop: submenús SOLO con clic (sin hover) + no cerrar al mover el ratón

(() => {
  const DESKTOP_MQ = window.matchMedia("(min-width: 990px)");
  const menu = document.querySelector(".header__inline-menu");
  if (!menu) return;

  // Cierra SOLO los siblings del mismo nivel (mismo <ul>)
  const closeSiblings = (currentDetails) => {
    const ul = currentDetails.closest("ul");
    if (!ul) return;

    ul.querySelectorAll(":scope > li > details[open]").forEach((d) => {
      if (d !== currentDetails) d.removeAttribute("open");
    });
  };

  // Cerrar todo al clicar fuera (desktop)
  document.addEventListener("click", (e) => {
    if (!DESKTOP_MQ.matches) return;
    if (menu.contains(e.target)) return;
    menu.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
  });

  // ESC para cerrar (desktop)
  document.addEventListener("keydown", (e) => {
    if (!DESKTOP_MQ.matches) return;
    if (e.key !== "Escape") return;
    menu.querySelectorAll("details[open]").forEach((d) => d.removeAttribute("open"));
  });

  menu.querySelectorAll("details").forEach((details) => {
    const summary = details.querySelector("summary");
    if (!summary) return;

    // SOLO clic en desktop
    summary.addEventListener("click", (e) => {
      if (!DESKTOP_MQ.matches) return;

      e.preventDefault();
      e.stopPropagation();

      const wasOpen = details.hasAttribute("open");

      closeSiblings(details);

      if (wasOpen) details.removeAttribute("open");
      else details.setAttribute("open", "");
    });
  });
})();

